/* NUT Biscoitos - Brinde Automatico v6 (Horizon) */
(function() {
  'use strict';

  var REGRAS = {
    '47596412666019': ['47394990358691'],
    '47596330254499': ['47394990358691', '47394979741859']
  };
  var GATILHOS = Object.keys(REGRAS);
  var BRINDES = ['47394990358691', '47394979741859'];
  var MARCADOR_BRINDE = '_nut_brinde_auto';
  var processando = false;

  function lerCarrinho() {
    return fetch('/cart.js', { cache: 'no-store' }).then(function(r) { return r.json(); });
  }

  /**
   * Verifica se um item específico do carrinho é um brinde adicionado pelo script.
   * Só considera brinde se tiver o marcador interno.
   */
  function ehBrindeAutomatico(item) {
    return item.properties &&
           item.properties[MARCADOR_BRINDE] === 'true';
  }

  /**
   * Conta quantos brindes automáticos de cada ID já existem no carrinho.
   */
  function contarBrindesAutomaticos(carrinho) {
    var contagem = {};
    carrinho.items.forEach(function(item) {
      if (ehBrindeAutomatico(item)) {
        var idStr = String(item.variant_id);
        contagem[idStr] = (contagem[idStr] || 0) + item.quantity;
      }
    });
    return contagem;
  }

  function calcularFaltando(carrinho) {
    var ids = carrinho.items.map(function(i) { return String(i.variant_id); });
    var brindesJaAutomaticos = contarBrindesAutomaticos(carrinho);
    var faltando = [];

    GATILHOS.forEach(function(gatilho) {
      if (ids.indexOf(gatilho) !== -1) {
        REGRAS[gatilho].forEach(function(b) {
          // Só adiciona se ainda não existe um brinde automático desse ID
          if (!brindesJaAutomaticos[b] && faltando.indexOf(b) === -1) {
            faltando.push(b);
          }
        });
      }
    });
    return faltando;
  }

  function adicionarBrindes(ids) {
    if (ids.length === 0) return Promise.resolve(null);
    var items = ids.map(function(id) {
      var props = {};
      props[MARCADOR_BRINDE] = 'true';
      return {
        id: parseInt(id, 10),
        quantity: 1,
        properties: props
      };
    });
    return fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/javascript'
      },
      body: JSON.stringify({ items: items })
    }).then(function(r) { return r.json(); });
  }

  /**
   * Remove brindes AUTOMÁTICOS órfãos (que foram adicionados pelo script
   * mas não têm mais gatilho no carrinho).
   * Produtos comprados avulsos pelo cliente NÃO são tocados.
   */
  function removerOrfaos() {
    return lerCarrinho().then(function(carrinho) {
      var ids = carrinho.items.map(function(i) { return String(i.variant_id); });
      var ativos = GATILHOS.filter(function(g) { return ids.indexOf(g) !== -1; });
      var validos = {};
      ativos.forEach(function(g) {
        REGRAS[g].forEach(function(b) { validos[b] = true; });
      });

      var atualizacoes = {};
      var mudou = false;
      carrinho.items.forEach(function(item) {
        var idStr = String(item.variant_id);
        // SÓ remove se for brinde automático E o gatilho dele não estiver mais no carrinho
        if (ehBrindeAutomatico(item) && BRINDES.indexOf(idStr) !== -1 && !validos[idStr]) {
          atualizacoes[item.key] = 0;
          mudou = true;
        }
      });

      if (mudou) {
        return fetch('/cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ updates: atualizacoes })
        }).then(function() { return true; });
      }
      return false;
    });
  }

  function notificarHorizon(source) {
    return lerCarrinho().then(function(cart) {
      if (typeof window.Shopify !== 'undefined') {
        try {
          import('@theme/events').then(function(mod) {
            if (mod && mod.CartUpdateEvent) {
              var evt = new mod.CartUpdateEvent(cart, source || 'nut-brinde', {
                itemCount: cart.item_count,
                source: source || 'nut-brinde',
                sections: {}
              });
              document.dispatchEvent(evt);
            }
          }).catch(function() {
            dispararEventoSimples(cart, source);
          });
        } catch (e) {
          dispararEventoSimples(cart, source);
        }
      } else {
        dispararEventoSimples(cart, source);
      }
    });
  }

  function dispararEventoSimples(cart, source) {
    document.dispatchEvent(new CustomEvent('cart:update', {
      bubbles: true,
      detail: {
        data: {
          itemCount: cart.item_count,
          source: source || 'nut-brinde'
        },
        cart: cart
      }
    }));
    document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
      bubbles: true,
      detail: { cart: cart }
    }));
  }

  function processar(source) {
    if (processando) return Promise.resolve();
    processando = true;
    return lerCarrinho()
      .then(function(carrinho) {
        var faltando = calcularFaltando(carrinho);
        if (faltando.length > 0) {
          return adicionarBrindes(faltando).then(function() {
            return notificarHorizon(source);
          });
        }
        return removerOrfaos().then(function(removeu) {
          if (removeu) return notificarHorizon(source);
        });
      })
      .catch(function(e) { console.error('NUT - erro:', e); })
      .then(function() { processando = false; });
  }

  var fetchOriginal = window.fetch;
  window.fetch = function() {
    var args = arguments;
    var url = args[0];
    var urlStr = typeof url === 'string' ? url : (url && url.url) || '';
    var eCarrinho = urlStr.indexOf('/cart/add') !== -1 ||
                    urlStr.indexOf('/cart/change') !== -1 ||
                    urlStr.indexOf('/cart/update') !== -1;

    var promise = fetchOriginal.apply(this, args);

    if (eCarrinho && !processando) {
      promise.then(function(resp) {
        if (resp && resp.ok !== false) {
          setTimeout(function() { processar('fetch-intercept'); }, 100);
        }
      }).catch(function() {});
    }
    return promise;
  };

  document.addEventListener('cart:update', function(e) {
    if (processando) return;
    if (e.detail && e.detail.data && e.detail.data.source === 'nut-brinde') return;
    setTimeout(function() { processar('cart-update-listener'); }, 100);
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function() { processar('page-load'); });
  } else {
    processar('page-load');
  }
})();